/*global Splide, Video a*/

document.addEventListener("DOMContentLoaded", () => {
  var secondarySlider = new Splide( '#secondary-news-slider', {
    fixedWidth  : 140,
    height      : 100,
    cover       : true,
    gap         : 10,
    isNavigation: true
  } ).mount(window.splide.Extensions);

  var primarySlider = new Splide( '#primary-news-slider', {
    type       : 'fade',
    arrows     : false,
    width       : '100%',
    pagination : false,
    cover      : false,
    video: {
        playerOptions: {
          youtube: {
            playlist: 'undefined',
            autoplay: true,
            enablejsapi: true,
            fs: true
          }
        },
        autoplay: true,
        loop: true,
        mute: true,
        origin: 'georges-imac.local'
      }
    });

  primarySlider.sync( secondarySlider ).mount(window.splide.Extensions);

});
